<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import LoadingMessage from '../LoadingMessage.vue';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader,XLSX, saveAs,LoadingMessage },
    data() {
        return {
            title: "Starter Page",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            productos:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            fileLicitacion:null,
            buttonDisabled: true,
            isLoading:false,
            json_data:[],
            json_data2:[{
                'codigo':'',
                'nombre_producto':'',
                'precio_estudiante':'',
                'precio_normal':'',
                'stock':'',
                'nombre_lista':'',
                'universidad':''
            }],
            json_data3:[],
        };
    },
    computed:{
        rows() {
            return this.productos.length;
        },
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.productos.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.codigo.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.nombre_producto.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.productos.length / this.perPage);
        },
    },
    methods:{
        uploadFileLicitacion() {
            this.isLoading=true
            let formData = new FormData();
            formData.append('file', this.fileLicitacion);

            axios.post('/api/subir_lista', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
            
                if(response.data.estado){
                    this.actualizar()
                    this.isLoading=false
                    this.msg('success',response.data.mensaje)
                }else{
                    this.msg('error',response.data.mensaje)
                }
            });
        },
        onFileLicitacionChange(e) {
            this.fileLicitacion = e.target.files[0];
            console.log("Archivo seleccionado:", this.fileLicitacion);
            this.buttonDisabled =false;
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        actualizar(){
            axios.get('/api/productos_lista/1').then(res=>{
                this.productos=res.data.productos;
                this.json_data=this.productos;
            });
            axios.get('/api/productos_sin_ficha/1').then(res=>{
                this.json_data3=res.data.no_encontrados;
            });
        },
        exportToExcel(jsondata,name) {
            const jsonData = jsondata;
            if (!jsonData || jsonData.length === 0) {
                alert("No hay datos para exportar.");
                return;
            }

            const headers = ["Codigo", "Producto", "P/ESTUDIANTE C/IVA", "P/LISTA BASE C/IVA", "Stock", "Nombre Lista", "Universidad"];
            const keys = ["codigo", "nombre_producto", "precio_estudiante", "precio_normal", "stock"];

            const groupedData = {};

            // Recorrer los productos y agruparlos por cada lista a la que pertenecen
            jsonData.forEach(product => {
                if (product.listas && product.listas.length > 0) {
                    product.listas.forEach(lista => {
                        const groupKey = `${lista.nombre_lista} - ${lista.universidad}`;
                        if (!groupedData[groupKey]) {
                            groupedData[groupKey] = [];
                        }
                        groupedData[groupKey].push([
                            product.codigo,
                            product.nombre_producto,
                            product.precio_estudiante,
                            product.precio_normal,
                            product.stock,
                            lista.nombre_lista,
                            lista.universidad
                        ]);
                    });
                }
            });
            // Crear hoja de cálculo
            const wb = XLSX.utils.book_new();
            const ws_data = [];
            //Agregar la primera fila con los encabezados
            ws_data.push(headers);
            // Llenar la hoja con datos agrupados
            Object.entries(groupedData).forEach(([groupTitle, rows]) => {
                // Agregar título de la sección
                //ws_data.push([groupTitle]);
                // Agregar encabezados
                //ws_data.push(headers);
                // Agregar filas
                ws_data.push(...rows);
                // Agregar una línea en blanco entre grupos
                //ws_data.push([]);
            });

            const ws = XLSX.utils.aoa_to_sheet(ws_data);
            XLSX.utils.book_append_sheet(wb, ws, "Lista");

            // Convertir a un archivo Excel
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const timestamp = new Date().toISOString().replace(/[-:T.]/g, "").slice(0, 14);
            const fileName = `${name}_${timestamp}.xlsx`;

            saveAs(data, fileName);
        },
        exportToExcel2(jsondata,name) {
            const jsonData = jsondata;
            if (!jsonData || jsonData.length === 0) {
                alert("No hay datos para exportar.");
                return;
            }
            const headers = ["Codigo", "Producto"]; // 🚀 Modifica esto
            const keys = ["codigo", "nombre_producto"]; // 🚀 Claves del JSON
            // Convertir los datos en formato de matriz con cabeceras
            const dataWithHeaders = [
                headers, // Primera fila con los títulos
                ...jsonData.map(item => keys.map(key => item[key] ?? "")) // Datos dinámicos
            ];
            // Crear hoja de cálculo desde JSON
            const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders);
            // Crear un libro de Excel
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Lista");
            // Convertir a un archivo Excel
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            // Crear Blob y descargar el archivo
            const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const timestamp = new Date().toISOString().replace(/[-:T.]/g, "").slice(0,14);
            const fileName = `${name}_${timestamp}.xlsx`;
            saveAs(data, fileName);
        },
        format_Valor_variable(val){
            const number = parseInt(val?.toString().replace(/[^0-9]/g, ""), 10);
            return number
                ? number.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
                : "$0";
        },
    },
    created(){
        this.actualizar()
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading"/>
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Cargar Lista desde CSV o Excel</h4>
                        <div>
                            <b-form-file
                                :state="Boolean(fileLicitacion)"
                                placeholder="Selecciona un archivo o arrástralo aquí..."
                                drop-placeholder="Suelta el archivo aquí..."
                                @change="onFileLicitacionChange"
                            ></b-form-file>

                            <b-button @click="uploadFileLicitacion" :disabled="buttonDisabled" variant="primary" class="mt-2">Importar Lista</b-button>
                        </div>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <p>Considerar que:</p>
                                <ul>
                                    <li>Guarda el menor stock entre los productos repetidos.</li>
                                    <li>Toma el mayor de precio estudiante entre los productos repetidos.</li>
                                    <li>Toma el mayor de precio normal entre los productos repetidos.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-12 mb-4 text-right" v-if="user.id==7">
                                <button class="btn btn-primary" @click="exportToExcel2(json_data3,'MaterialesEstudiantesSinFicha')">Exportar Sin Ficha</button>
                            </div>
                            <div class="col-md-12 mb-4 text-right">
                                <button class="btn btn-primary" @click="exportToExcel(json_data2,'PlantillaMaterialesEstudiantes')">Exportar Plantilla</button>
                                <button class="btn btn-primary" @click="exportToExcel(json_data,'ListaMaterialesEstudiantes')">Exportar Lista</button>
                            </div>
                            <div class="col-sm-12 col-md-6"></div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 10%;">Nº</th>
                                        <th style="width: 20%;">Código</th>
                                        <th style="width: 30%;">Nombre del Producto</th>
                                        <th style="width: 10%;">Precio Estudiante</th>
                                        <th style="width: 10%;">Precio Normal</th>
                                        <th style="width: 20%;">Stock</th>
                                        <th style="width: 20%;">Listas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in productos" :key="index">
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.codigo }}</td>
                                        <td>{{ item.nombre_producto }}</td>
                                        <td>{{ format_Valor_variable(item.precio_estudiante) }}</td>
                                        <td>{{ format_Valor_variable(Math.round(item.precio_normal)) }}</td>
                                        <td :class="parseInt(item.stock)<10?'bg-danger':''">{{ item.stock }}</td>
                                        <b-tooltip :target="'nombre-' + index" placement="top">
                                        {{ item.nombreslistas }}
                                        </b-tooltip>
                                        <td :id="'nombre-' + index">
                                        {{ item.nombreslistas.length > 10 ? item.nombreslistas.substring(0, 10) + '...' : item.nombreslistas }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>